/// <amd-dependency path="esri/core/tsSupport/declareExtendsHelper" name="__extends" />
/// <amd-dependency path="esri/core/tsSupport/decorateHelper" name="__decorate" />

import { subclass } from "esri/core/accessorSupport/decorators";
import Widget = require("esri/widgets/Widget");

import MinimalGallery, { MinimalGalleryState, reducers } from "./MinimalGallery";
import { router, startHistoryListener } from "./MinimalGallery/_utilities/router";
import { newStore, middlewares } from "../Component";

interface MainAppProps {
    boilerplate: __Component.Pojo;
    i18n: __Component.Pojo;
}

const { thunk, debug } = middlewares;

@subclass("esri.widgets.MinimalGallery")
export default class MainApp extends Widget {
    minimalGallery: MinimalGallery;
    returnValue: any = undefined;

    constructor(props: MainAppProps) {
        super();

        const store = newStore({
            reducers,
            parentWidget: this,
            initialState: {
                base: {
                    applicationBase: props.boilerplate,
                    applicationBaseResult: null,
                    i18n: props.i18n,
                    status: "loading",
                    loadMessage: "init"
                }
            },
            middlewares: [ thunk, router ]
        });
        this.minimalGallery = new MinimalGallery({
            key: "MinimalGallery", 
            store: store
        });

        startHistoryListener(this.minimalGallery.store);
    }

    render() {
        return this.minimalGallery.render();
    }
}



// WEBPACK FOOTER //
// ./src/mainApp/Widget.tsx